import { IBotMessage } from '../../../../types/conversations'
import { msToHour } from '../../../../utils/time'
import SanitizeHTML from '../../../SanitizeHTML/SanitizeHTML'
import Metadata from '../Metadata/Metadata'

import styles from './bot-message.module.scss'

interface IBotMessageProps {
    message: IBotMessage
}

function BotMessage(props: IBotMessageProps) {
    const { message } = props

    return (
        <div className={styles.botMessage__wrapper}>
            <div className={styles.botMessage}>
                <SanitizeHTML html={message.text} />
                <Metadata
                    date={message.timestamp}
                    className={styles.botMessage__metadata}
                />
            </div>
            <div className={styles.botMessage__hour}>
                {msToHour(message.timestamp)}
            </div>
        </div>
    )
}

export default BotMessage
